import { useCallback } from 'react';
import LogRocket from 'logrocket';

const logRocketFreightRegistrationSucceededEventName = 'FREIGHT_REGISTRATION_SUCCEEDED';

export const useTrackFreightRegistrationSucceeded = (): (() => void) => {
  return useCallback(() => {
    const environment = process.env.NODE_ENV ?? 'development';
    LogRocket.track(logRocketFreightRegistrationSucceededEventName, { env: environment });
  }, []);
};
